import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { translator } from 'mage-i18n';

import { withResponsive } from 'mage-components';
import {
  RadioBullet,
  SpacerVertical,
  ParagraphTertiary,
  Typography,
  Avatar,
} from '@klarna/bubble-ui';

import { CardsSelectorIconComponent } from '../CardsSelectorIcon';

export const T_PREFIX = 'products-fe.containers.sensitive_goods';

const MainCard = styled.div`
  width: 100%;
  min-width: 260px;
  max-width: 315px;
`;

const Card = styled.div`
  box-sizing: border-box;
  box-shadow: ${({ selected }) => (selected ? '0px 9px 25px rgba(0, 0, 0, 0.15)' : 'unset')};
  border: ${({ selected, error }) => {
    if (error) {
      return '2px solid #C0221A';
    }
    if (selected) {
      return '2px solid #267a9c';
    }
    return '1px solid #F0F1F1';
  }};
  border-radius: 8px;

  /* so that disabledReason text box does not overlap with the above component */
  margin-top: ${({ disabled, mobile }) => (disabled && mobile ? '40px' : 'unset')};
`;

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 200px;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};

  background: ${({ disabled }) => (disabled ? '#f0f1f1' : 'unset')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : 'unset')};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CardComponent = ({
  error,
  isMobile,
  isSelectedFn = () => null,
  id,
  onChange = () => null,
  enumTranslationFunction = (t, id) => ({
    title: t(`${T_PREFIX}.goodsCategories.${id}.title_2`),
    description: t(`${T_PREFIX}.goodsCategories.${id}.description_2`),
  }),
  t,
  cyElementId,
}) => {
  const selected = isSelectedFn(id);
  const { title, description } = enumTranslationFunction(t, id);

  return (
    <MainCard {...cyElementId}>
      <Card error={error} mobile={isMobile} selected={selected}>
        <Container onClick={() => onChange(id)}>
          <Row>
            <TitleContainer>
              <Avatar icon={CardsSelectorIconComponent(id)} />
            </TitleContainer>

            <div style={{ marginTop: 1, marginRight: 3 }}>
              <RadioBullet error={error} checked={selected} />
            </div>
          </Row>

          <SpacerVertical small />
          <Typography textToken="text-style/text/super-paragraphs/body/bold">{title}</Typography>
          <SpacerVertical small />
          <Row>
            <ParagraphTertiary correctFootprint light>
              {description}
            </ParagraphTertiary>
          </Row>
        </Container>
      </Card>
      <SpacerVertical small />
    </MainCard>
  );
};

CardComponent.propTypes = {
  id: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isSelectedFn: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  cyElementId: PropTypes.object,
  enumTranslationFunction: PropTypes.func,
  error: PropTypes.bool,
};

export default compose(
  withResponsive,
  connect(state => ({
    t: translator(state),
  })),
)(CardComponent);
